const Color = {
  // primary (blue)
  primary_1: '#F5FBFF',
  primary_2: '#E3F4FF',
  primary_3: '#8FCFFF',
  primary_4: '#5EBCFF',
  primary_5: '#006BD6',
  primary_6: '#034CB7',
  primary_7: '#002A7C',
  // secondary (green)
  secondary_1: '#CAFCDF',
  secondary_2: '#95FBCB',
  secondary_3: '#62F3BA',
  secondary_4: '#39E7B4',
  secondary_5: '#00D8AD',
  secondary_6: '#00B9A7',
  secondary_7: '#019B9B',
  secondary_8: '#00727D',
  secondary_9: '#00545C',
  // gray
  gray_1: '#F6F7F8',
  gray_2: '#EDF0F5',
  gray_3: '#D3DAE2',
  gray_4: '#B7C2CE',
  gray_5: '#8595A8',
  gray_6: '#627487',
  gray_7: '#2F3842',
  gray_8: '#1C2227',
  // text
  text_primary: '#2F3842',
  text_secondary: '#627487',
  text_white: '#FFFFFF',
  // sementic
  white: '#FFFFFF',
  black: '#000000',
  line: '#EDF0F5',
  error: '#E20000',
  error_light: '#FEF2F2',
} as const

type ColorType = typeof Color

type ColorKeys = keyof ColorType

type ColorValues = ColorType[keyof ColorType]

export { Color }
export type { ColorType, ColorKeys, ColorValues }
